<div class="page-container">
  <div class="top-toolbar u-margin-bottom-50">
    <div class="sub-title">SETTINGS</div>
    <div class="o-flex o-flex--align-items-center">
      <div class="title u-margin-right-10">Test Equipment</div>
      <app-label [text]="'General'" [isCommon]="true" [labelHeight]="24"></app-label>
    </div>
  </div>
  <mat-tab-group (selectedTabChange)="onTabChanged();">
    <mat-tab label="Speed & Distance">
      <div class="u-margin-top-20">
        <p class="test-equipment--header-color u-font-weight-400 u-font-size-21 u-margin-bottom-30">Equipment to measure speed</p>
        <div class="o-flex o-flex--justify-left o-flex--wrap">
          <app-test-equipment
            (onChange)="onChangeEquipment($event)"
            [equipmentDeviceList]="originalDeviceList"
            class="u-margin-right-10 u-margin-bottom-10"
            *ngFor="let item of speedDistanceDeviceList"
            [isExpanded]="isExpand"
            [config]="item"
            [context]="testCreationType"></app-test-equipment>
        </div>
      </div>
    </mat-tab>
    <mat-tab label="Ergometers & Powermeters">
      <div class="u-margin-top-20">
        <p class="test-equipment-page--header-color u-font-weight-400 u-font-size-21 u-margin-bottom-30">Equipment to measure power</p>
        <div class="o-flex o-flex--justify-left o-flex--wrap">
          <app-test-equipment
            (onChange)="onChangeEquipment($event)"
            [equipmentDeviceList]="originalDeviceList"
            class="u-margin-right-10 u-margin-bottom-10"
            *ngFor="let item of ergometersDeviceList"
            [isExpanded]="isExpand"
            [config]="item"
            [context]="testCreationType"></app-test-equipment>
        </div>
      </div>
    </mat-tab>
    <mat-tab label="Physiological measurements">
      <div class="u-margin-top-20">
        <p class="test-equipment-page--header-color u-font-weight-400 u-font-size-21 u-margin-bottom-30">Equipment used to measure physiological data</p>
        <div class="o-flex o-flex--justify-left o-flex--wrap">
          <app-test-equipment
            (onChange)="onChangeEquipment($event)"
            [equipmentDeviceList]="originalDeviceList"
            class="u-margin-right-10 u-margin-bottom-10"
            *ngFor="let item of physiologicalMeasurementsDeviceList"
            [isExpanded]="isExpand"
            [config]="item"
            [context]="testCreationType"></app-test-equipment>
        </div>
      </div>
    </mat-tab>
  </mat-tab-group>
  <button class="width-100-percent u-margin-top-50" mat-raised-button color="primary" [disabled]="isDisabled" (click)="save()">Save</button>
</div>
